import type { Review } from '@typings/api/reviews';
import { atom } from 'jotai';

export const reviewsCollectionAtom = atom<Review[]>([]);
export const currentResultsCountAtom = atom<number>(0);
export const amountToRenderAtom = atom<number>(5);
